<template>
  <div>
    <base-card>
      <v-card-text>
        <v-form ref="form">
          <base-card>
            <v-card-title>Importación de datos desde HIOFFICE</v-card-title>
            <div class="line-text pad-text">

              <v-card-text class="line-text">
                <v-checkbox
                  color="rgb(204 33 40)"
                  label="Por archivo plano"
                  v-model="importType"
                  value="file"
                />

                <v-row v-if="importType == 'file'">
                  <v-col cols="12" sm="4">
                    <v-select
                      label="Entidad a importar"
                      :items="entities"
                      item-text="description"
                      return-object
                      v-model="dataFilter.entity"
                      outlined
                      dense
                      :rules="requiredRule"
                    />
                  </v-col>

                  <v-col cols="12" sm="4" v-if="requiresDateRangeFile">
                    <v-dialog v-model="modalStart" width="300px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          label="Fecha inicial"
                          v-model="dataFilter.startDate"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          dense
                          :rules="
                            requiresDateRangeFile ? [requiredDateRule] : []
                          "
                          :disabled="!requiresDateRangeFile"
                        />
                      </template>

                      <v-date-picker
                        v-model="dataFilter.startDate"
                        @input="modalStart = false"
                      />
                    </v-dialog>
                  </v-col>

                  <v-col cols="12" sm="4" v-if="requiresDateRangeFile">
                    <v-dialog v-model="modalEnd" width="300px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          label="Fecha final"
                          v-model="dataFilter.endDate"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          dense
                          :rules="
                            requiresDateRangeFile ? [requiredDateRule] : []
                          "
                          :disabled="!requiresDateRangeFile"
                        />
                      </template>

                      <v-date-picker
                        v-model="dataFilter.endDate"
                        @input="modalEnd = false"
                      />
                    </v-dialog>
                  </v-col>

                  <v-col cols="12" sm="4">
                    <v-file-input
                      v-model="file"
                      label="Archivo"
                      prepend-icon=""
                      prepend-inner-icon="mdi-file-upload"
                      outlined
                      dense
                      clearable
                      placeholder="Seleccione un archivo"
                      :rules="fileRules"
                      accept=".json,application/json"
                    />
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-text class="mt-3 line-text">
                <v-checkbox
                  color="rgb(204 33 40)"
                  label="Por Bridge WS"
                  v-model="importType"
                  value="bridge"
                />

                <v-row v-if="importType == 'bridge'" class="d-block">
                  <v-row cols="12">
                    <v-col cols="12" sm="4">
                      <v-text-field
                        label="Usuario de acceso a Bridge WS"
                        outlined
                        dense
                        v-model="parameters.userBridge"
                        :rules="requiredRule"
                      />
                    </v-col>

                    <v-col cols="12" sm="4">
                      <v-text-field
                        label="Clave de acceso a Bridge WS"
                        type="password"
                        outlined
                        dense
                        v-model="parameters.passwordBridge"
                        :rules="requiredRule"
                      />
                    </v-col>

                    <v-col cols="12" sm="4" class="tx-center">
                      <v-btn
                        color="rgb(204 33 40)"
                        class="white--text border-button"
                        @click="testConnectionBridge()"
                      >
                        TEST DE CONEXIÓN A BRIDGE WS
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-row cols="12">
                    <v-col cols="12" sm="4">
                      <v-select
                        v-model="companyAccountant"
                        :items="optionCompanyAccountang"
                        item-text="description"
                        item-value="accountingCompanyCode"
                        required
                        outlined
                        dense
                        :rules="requiredRule"
                        :disabled="this.disabledCompanyAccountant"
                      />
                    </v-col>
                  </v-row>

                  <v-row cols="12">
                    <v-col cols="12" sm="4">
                      <v-select
                        label="Entidad a importar"
                        :items="entities"
                        item-text="description"
                        return-object
                        multiple
                        v-model="dataFilter.entities"
                        outlined
                        dense
                      />
                    </v-col>

                    <v-col cols="12" sm="4" v-if="requiresDateRangeBridge">
                      <v-dialog
                        v-model="modalStartBridge"
                        width="300px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            label="Fecha inicial"
                            v-model="dataFilter.startDateBridge"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            dense
                            :rules="
                              requiresDateRangeBridge ? [requiredDateRule] : []
                            "
                            :disabled="!requiresDateRangeBridge"
                          />
                        </template>

                        <v-date-picker
                          v-model="dataFilter.startDateBridge"
                          @input="modalStartBridge = false"
                        />
                      </v-dialog>
                    </v-col>

                    <v-col cols="12" sm="4" v-if="requiresDateRangeBridge">
                      <v-dialog v-model="modalEndBridge" width="300px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            label="Fecha final"
                            v-model="dataFilter.endDateBridge"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            dense
                            :rules="
                              requiresDateRangeBridge ? [requiredDateRule] : []
                            "
                            :disabled="!requiresDateRangeBridge"
                          />
                        </template>

                        <v-date-picker
                          v-model="dataFilter.endDateBridge"
                          @input="modalEndBridge = false"
                        />
                      </v-dialog>
                    </v-col>
                  </v-row>


                </v-row>
              </v-card-text>
              <v-row justify="center" class="my-4" v-if="showAlert">
                <v-col cols="12" sm="6">
                  <v-alert
                    :type="alertType"
                    dense
                    outlined
                    border="left"
                    colored-border
                    class="my-4"
                  >
                    {{ alertMessage }}
                  </v-alert>
                </v-col>
              </v-row>
              <v-card-actions class="justify-end pad-text">
                <v-btn
                  color="rgb(204 33 40)"
                  class="white--text border-button px-8 py-4"
                  min-width="180"
                  :disabled="!canSubmit"
                  @click.prevent="generateFormats()"
                >
                  IMPORTAR
                </v-btn>
              </v-card-actions>
            </div>

            <v-card-text class="mt-5 line-text">
              <v-toolbar flat dense>
                <v-toolbar-title>
                  Tabla de importaciones por entidad
                </v-toolbar-title>

                <v-spacer></v-spacer>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      :loading="loadingTable"
                      :disabled="loadingTable"
                      color="rgb(204 33 40)"
                      class="white--text border-button"
                      @click="getEntitiesImport()"
                    >
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                  </template>

                  <span>Refrescar tabla</span>
                </v-tooltip>
              </v-toolbar>

              <v-data-table
                :headers="headers"
                :items="dataTable"
                :search="search"
                :loading="loadingTable"
                loading-text="Cargando Importaciones..."
                class="elevation-1 mt-5"
              >
                <template v-slot:[`item.statusDescription`]="{ item }">
                  <v-chip
                    :color="getStatusColor(item.statusDescription)"
                    medium
                    class="white--text border-button px-4"
                  >
                    {{ item.statusDescription }}
                  </v-chip>
                </template>
                <template v-slot:[`item.contentStartDate`]="{ item }">
                  <div style="min-width: 100px;">
                    {{ formatDate(item.contentStartDate) }}
                  </div>
                </template>
                <template v-slot:[`item.contentEndDate`]="{ item }">
                  <div style="min-width: 90px;">
                    {{ formatDate(item.contentEndDate) }}
                  </div>
                </template>
                <template v-slot:[`item.creationDate`]="{ item }">
                  <div style="min-width: 90px;">
                    {{ item.creationDate }}
                  </div>
                </template>
                <template v-slot:[`item.endDate`]="{ item }">
                  <div style="min-width: 90px;">
                    {{ item.endDate }}
                  </div>
                </template>
                <template v-slot:[`item.comment`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span class="truncate-text" v-bind="attrs" v-on="on">
                        {{ item.comment }}
                      </span>
                    </template>
                    <span>{{ item.comment }}</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card-text>
          </base-card>
        </v-form>
      </v-card-text>
    </base-card>
    <v-overlay :value="loading" absolute opacity="0.6">
      <v-progress-circular
        indeterminate
        size="64"
        color="rgb(204 33 40)"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import { environment } from "@/data/environment";

export default {
  props:{
    selectComponent:{
      type: String,
      default: null
    }
  },
  data() {
    return {
      importType: "bridge", // 'file' | 'bridge'

      modalStart: false,
      modalEnd: false,
      modalStartBridge: false,
      modalEndBridge: false,
      companyAccountant: null,

      entities: [],

      dataFilter: {
        entity: null,
        entities: [],
        startDate: null,
        endDate: null,
        endDateBridge: null,
        startDateBridge: null,
      },
      file: "",
      headers: [
        { text: "Entidad", value: "entityDescription", align: "center" },
        { text: "Estado", value: "statusDescription", align: "center" },
        {
          text: "Fecha inicial del contenido",
          value: "contentStartDate",
          align: "center",
        },
        {
          text: "Fecha final del contenido",
          value: "contentEndDate",
          align: "center",
        },
        { text: "Fecha de creación", value: "creationDate", align: "center", minWidth: 150},
        { text: "Fecha de finalización", value: "endDate", align: "center"},
        {
          text: "Observación",
          value: "comment",
          width: 380,
          class: "col-message",
          align: "center",
        },
      ],
      dataFilterToken: {
        company: null,
      },
      token: null,
      showAlert: false,
      alertMessage: "",
      alertType: "success",
      loading: false,
      loadingTable: false,
      fileRules: [
        (v) => !!v || "Debe seleccionar un archivo",
        (v) =>
          !v ||
          v.type === "application/json" ||
          v.name.endsWith(".json") ||
          "Solo se permiten archivos JSON",
      ],
      dataTable: [],
      parameters: {
        userBridge: null,
        passwordBridge: null,
      },
      idCompany: null,
      requiredRule: [(v) => !!v || "Campo obligatorio"],
      optionsMiniorAccount: [
        { text: "Si", value: true },
        { text: "No", value: false },
      ], 
      disabledCompanyAccountant: true,
      optionCompanyAccountang: [],
      search: ""
    };
  },
  watch: {
    requiresDateRangeFile(newVal) {
      if (!newVal) {
        this.dataFilter.startDate = null;
        this.dataFilter.endDate = null;
      }
    },
    requiresDateRangeBridge(newVal) {
      if (!newVal) {
        this.dataFilter.startDateBridge = null;
        this.dataFilter.endDateBridge = null;
      }
    }
  },
  mounted() {
    this.idCompany = JSON.parse(atob(localStorage.getItem("uid"))).idcompania;
    this.fetchToken();
  },
  computed: {
    requiresDateRangeFile() {
      return !!this.dataFilter.entity?.requiresDateRange;
    },
    requiresDateRangeBridge() {
      return this.dataFilter.entities.some((e) => e.requiresDateRange);
    },
    canSubmit() {
      if (this.importType === "file") {
        return !!this.dataFilter.entity && !!this.file;
      }

      if (this.importType === "bridge") {
        return (
          this.dataFilter.entities.length > 0 &&
          this.parameters.userBridge &&
          this.parameters.passwordBridge &&
          this.companyAccountant
        );
      }

      return false;
    }
  },
  methods: {
    setAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.showAlert = true;
      setTimeout(() => (this.showAlert = false), 4000);
    },

    resetAlert() {
      this.alertMessage = "";
      this.alertType = "success";
      this.showAlert = false;
    },

    clearFields() {
      this.dataFilter = {
        company: null,
        consecutive: "",
      };
      this.search = "";
      this.token = null;
      this.infoInvoice = [];
      this.showModal = false;
    },
    onAccept() {
      this.modal = false;
    },
    async fetchToken() {
      this.loading = true;

      try {
        const tokenInfo = JSON.parse(localStorage.getItem("tokenCompany"));

        if (tokenInfo && tokenInfo.idCompany === this.idCompany && tokenInfo.expiresAt > Date.now()) {
          this.token = tokenInfo.token;
        } else {
          const token = await this.$store.dispatch("fetchToken/getTokenByCompany",
            this.idCompany
          );

          if (!token) {
            this.setAlert("error", "Error al obtener token");
            return;
          }

          this.token = token;
          localStorage.setItem("tokenCompany", JSON.stringify({idCompany: this.idCompany, token, expiresAt: Date.now() + 6 * 60 * 1000,}));
        }

        await this.getEntities();
        await this.getParametersBridge();
        await this.getEntitiesImport();
      } catch (e) {
        this.setAlert("error", "Error al obtener token");
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async getEntities() {
      this.loading = true;

      try {
        this.entities = await this.$store.dispatch("dataImportExogena/getEntities", {
          idCompany: this.idCompany,
          application: this.selectComponent,
          token: this.token,
        });
      } catch (error) {
        this.setAlert("error", "Ocurrió un error al extraer las entidades.");
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async getParametersBridge() {
      this.loading = true;
      try {
        const data = await this.$store.dispatch("dataImportExogena/companyParameters", {
          idCompany: this.idCompany,
          token: this.token,
        });

        this.parameters.userBridge = data.find(
          item => item.name === "EXOGENA_BRIDGE_WS_EMAIL"
        )?.value || null

        this.parameters.passwordBridge = data.find(
          item => item.name === "EXOGENA_BRIDGE_WS_PASSWORD"
        )?.value || null

        const accountingCompanyCode = data.find(
          item => item.name === "EXOGENA_ACCOUNTING_COMPANY_CODE"
        )?.value || null

        const accountingCompanyName = data.find(
          item => item.name === "EXOGENA_ACCOUNTING_COMPANY_NAME"
        )?.value || null

        this.optionCompanyAccountang = accountingCompanyCode && accountingCompanyName
          ? [{
              accountingCompanyCode: accountingCompanyCode,
              description: accountingCompanyName
            }]
          : []

        this.companyAccountant = accountingCompanyCode || null;
        
      } catch (error) {
        console.error(
          "Error al traer los parametros de la compañia para consulta bridge:",
          error
        );
        this.setAlert("error", "Ocurrió un error durante la eliminacion.");
      } finally {
        this.loading = false;
      }
    },
    async getEntitiesImport() {
      this.loadingTable = true;
      try {
        this.dataTable = await this.$store.dispatch("dataImportExogena/getEntitiesImport", {
          idCompany: this.idCompany,
          token: this.token,
        });
      } catch (error) {
        console.error("Error al extraer las importaciones echas:", error);
        this.setAlert("error", "Ocurrió un error durante la eliminacion.");
      } finally {
        this.loadingTable = false;
      }
    },
    requiredDateRule(value) {
      return !!value || "La fecha es obligatoria";
    },
    getStatusColor(status) {
      if (!status) return "grey";

      switch (status.toLowerCase()) {
        case "procesado":
          return "rgb(26 157 31)";
        case "error":
          return "rgb(204 33 40)";
        case "pendiente":
          return "orange";
        default:
          return "grey";
      }
    },
    async testConnectionBridge() {
      this.loading = true;

      try {
        const response = await this.$store.dispatch("dataImportExogena/testConnectionBridge", {
          idCompany: this.idCompany,
          token: this.token,
          authenticationBridgeWS: {
            email: this.parameters.userBridge,
            password: this.parameters.passwordBridge,
          },
        });

        this.optionCompanyAccountang = response.accountingCompanies
        this.disabledCompanyAccountant = false
        this.setAlert("success", response.message);
      } catch (error) {
        console.error(
          "Error al generar el test de Bridge:",
          error.response ?? error
        );
        this.setAlert(
          "error",
          error.response?.data?.message ||
            "Ocurrió un error al validar la conexión"
        );
      } finally {
        this.loading = false;
      }
    },
    generateFormats() {
      if (!this.$refs.form.validate()) return;

      if (this.importType === "file") {
        this.sendFileImport();
      }

      if (this.importType === "bridge") {
        this.sendBridgeImport();
      }
    },
    async sendFileImport() {
      
      this.loading = true;
      try {
      
        const response = await this.$store.dispatch("dataImportExogena/sendFileImport", {
            idCompany: this.idCompany,
            token: this.token,
            entity: this.dataFilter.entity.entityCode,
            file: this.file,
            startDate: this.dataFilter.startDate,
            endDate: this.dataFilter.endDate,
            requiresDateRange: this.requiresDateRangeFile,
        });

        this.resetForm()
        await this.getEntitiesImport();
        this.setAlert("success", response.message);

      } catch (error) {
        this.setAlert("error", "Error al importar archivo");
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async sendBridgeImport() {
      this.loading = true;
      try {
        
        const response = await this.$store.dispatch("dataImportExogena/sendBridgeImport", {
            idCompany: this.idCompany,
            token: this.token,
            dataFilter: this.dataFilter,
            parameters: this.parameters,
            companyAccountant: this.companyAccountant,
        });

        this.resetForm()
        this.disabledCompanyAccountant = true
        await this.getEntitiesImport();
        this.setAlert("success", response.message);
      } catch (error) {
        this.setAlert("error", "Error al importar por Bridge");
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.dataFilter.startDate = null
      this.dataFilter.endDate = null
      this.file = null
      this.dataFilter.entity = null
      this.dataFilter.entities = []
    },
    formatDate(date) {
      return date ? date.substring(0, 10) : null;
    }
  },
};
</script>
<style scoped>
.icon-warning {
  color: rgb(204 33 40);
  font-size: 100px;
}
.tx-center {
  text-align: center;
}
.line-text {
  border: 1px solid #dfdfdf !important;
  border-radius: 15px;
}
.pad-text {
  padding: 10px;
}
.col-message {
  max-width: 380px;
  width: 380px;
}

.truncate-text {
  display: inline-block;
  max-width: 380px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
